import { render, staticRenderFns } from "./AtlasConsolidatedPhysicalCountReport.vue?vue&type=template&id=6a5154c6&"
import script from "./AtlasConsolidatedPhysicalCountReport.vue?vue&type=script&lang=js&"
export * from "./AtlasConsolidatedPhysicalCountReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports